import { addDefaultProps, addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'

import { addTranslationHelpers } from '../../../../utils/addTranslationHelpers'
import shuffleBackground from 'assets/shuffle.svg'
import shuffleIcon from 'assets/shuffle-icon.svg'
import { pulseAnimation, sansSerifFontFamily } from 'utils/styles'
import {
  SHUFFLE_BUTTON_BACKGROUND_Z_INDEX,
  SHUFFLE_BUTTON_VALUE_Z_INDEX,
} from 'utils/zIndex'

const useStyles = createUseStyles({
  '@keyframes pulseAnimation': pulseAnimation,
  button: {
    animation: '$pulseAnimation 3s infinite',
    position: 'relative',
    margin: 0,
    padding: 0,
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    width: 48,
    height: 60,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontFamily: sansSerifFontFamily,
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '19.6px',
  },
  backgroundImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: SHUFFLE_BUTTON_BACKGROUND_Z_INDEX,
  },
  value: {
    zIndex: SHUFFLE_BUTTON_VALUE_Z_INDEX,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  disabled: {
    opacity: 0.5,
  },
})

interface Props {
  onClick: () => void
  value?: string
  className?: string
  disabled?: boolean
}

export const ShuffleButton: FC<Props> = flowMax(
  addDisplayName('ShuffleButton'),
  addDefaultProps({
    disabled: false,
  }),
  addProps(() => ({
    classes: useStyles(),
  })),
  addTranslationHelpers,
  ({ onClick, value, disabled, classes, className, t }) => (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cx(classes.button, disabled && classes.disabled, className)}
    >
      <object
        type="image/svg+xml"
        data={shuffleBackground}
        className={classes.backgroundImage}
      >
        {t('productDetail.shuffle')}
      </object>
      <div className={classes.value}>
        {value ? (
          value
        ) : (
          <img src={shuffleIcon} alt={t('productDetail.shuffle')} />
        )}
      </div>
    </button>
  )
)
